import React from 'react';
import { IconSvgProps } from '@models/common';

const PlagiarismDetectAI: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.9503 9.99961C15.9501 6.71369 13.2855 4.05 9.99956 4.05C6.71378 4.05021 4.05016 6.71382 4.04995 9.99961C4.04995 13.2856 6.71365 15.9502 9.99956 15.9504C13.2857 15.9504 15.9503 13.2857 15.9503 9.99961ZM18.0503 9.99961C18.0503 11.8437 17.4281 13.5419 16.3851 14.8992L21.7429 20.257C22.153 20.6671 22.153 21.3329 21.7429 21.743C21.3329 22.153 20.667 22.153 20.257 21.743L14.8992 16.3852C13.5419 17.4281 11.8436 18.0504 9.99956 18.0504C5.55385 18.0502 1.94995 14.4454 1.94995 9.99961C1.95016 5.55403 5.55398 1.95021 9.99956 1.95C14.4453 1.95 18.0501 5.5539 18.0503 9.99961Z'
        fill='currentColor'
      />
      <path
        d='M9.78937 6.1876C9.88195 5.93747 10.2362 5.93747 10.3287 6.1876L11.2556 8.69263C11.27 8.7315 11.2926 8.76681 11.3219 8.79614C11.3511 8.82547 11.3864 8.84812 11.4253 8.86254L13.9306 9.78946C14.1807 9.88203 14.1807 10.2362 13.9306 10.3288L11.4255 11.2557C11.3867 11.2701 11.3514 11.2927 11.322 11.322C11.2927 11.3512 11.2701 11.3865 11.2556 11.4254L10.3287 13.9304C10.2362 14.1808 9.88195 14.1808 9.78937 13.9304L8.86247 11.4256C8.84811 11.3868 8.82552 11.3515 8.79624 11.3221C8.76696 11.2928 8.73169 11.2702 8.69284 11.2557L6.18755 10.3288C5.93742 10.2362 5.93742 9.88203 6.18755 9.78946L8.69255 8.86254C8.73143 8.84818 8.76674 8.82559 8.79606 8.79631C8.82539 8.76704 8.84804 8.73176 8.86247 8.69291L9.78937 6.1876Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default PlagiarismDetectAI;
